"use client"

import { ComponentConfig } from "@measured/puck"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/pagination"
import { Autoplay, EffectFade, Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"

import { generateImagePath } from "../../../../../../utils/generateImagePath"
import { DefaultImage } from "../../../../external-components"
import { CommonCSSProps, CommonStylesProps } from "../../../lib/commonCSSProps"
import { convertCSSEditMode, generateResponsiveCSS } from "../../../lib/helper"
import "./customSwiper.css"
export interface CarouselProp extends CommonStylesProps {
  urls?:
    | string[]
    | {
        urls?: string[]
        titles?: string[]
      }
  titles?: string[]
  imageStyles?: {
    width: string
    height: string
    padding: string
    margin: string
    objectFit: "cover" | "contain" | "fill" | "none" | "scale-down"
  }
  titleStyles?: CommonCSSProps
  // fontSize?: string
  // color?: string
  // fontWeight?: string
  // lineHeight?: string
  // textAlign?: string
  // padding?: string
  // margin?: string
  // backgroundColor?: string
  // top?: string
  // left?: string
  // right?: string
  // zIndex?: string
  // maxWidth: string
  // }
  type: "fluid" | "custom" | "boxed"
}

export const RenderConfig: ComponentConfig<CarouselProp> = {
  render: ({ urls, titles, imageStyles, titleStyles, styles, responsiveType }: CarouselProp) => {
    const normalizedUrls = urls && Array.isArray(urls) ? urls : urls?.urls || [DefaultImage, DefaultImage, DefaultImage]

    const normalizedTitles = Array.isArray(urls) ? titles : urls?.titles || new Array(normalizedUrls.length).fill("")

    const id = `navigation-${Math.random().toString(36).substr(2, 9)}`

    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)
    const convertedCSSEditMode = styles && convertCSSEditMode(styles)
    const displayUrls = normalizedUrls.length > 0 ? normalizedUrls : [DefaultImage, DefaultImage, DefaultImage]
    const displayTitles =
      normalizedTitles && normalizedTitles.length > 0 ? normalizedTitles : new Array(displayUrls.length).fill("")

    return (
      <>
        {/* {responsiveCSS} */}
        <div id={id} className="relative">
          <Swiper
            modules={[Pagination, Autoplay, EffectFade]}
            spaceBetween={30}
            slidesPerView={1}
            effect={"fade"}
            pagination={{
              clickable: true,
              dynamicBullets: true,
              bulletClass: " custom-swiper-pagination-bullet",
              bulletActiveClass: "custom-swiper-pagination-bullet-active",
            }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }}
            loop={true}
          >
            {displayUrls.map((url, index) => (
              <SwiperSlide key={index} className="relative">
                {displayTitles[index] && (
                  <div
                    className="absolute lg:text-[74px] text-white font-bold p-0 m-0 lg:top-[252px] top-[100px] lg:left-[120px] left-6 right-auto z-10 max-w-[80%] text-5xl sm:leading-[40px]"
                    style={{
                      lineHeight: "64px",
                      textShadow: "0px 2px 3px rgba(0, 0, 0, 0.3), 0px 6px 10px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    {displayTitles[index]}
                  </div>
                )}
                <img
                  src={url ? generateImagePath(url, "large") : DefaultImage}
                  style={{
                    width: imageStyles?.width || "100%",
                    height: imageStyles?.height || "200px",
                    objectFit: imageStyles?.objectFit || "cover",
                    padding: imageStyles?.padding || "0px",
                    margin: imageStyles?.margin || "0px",
                  }}
                  className="cursor-pointer"
                  alt={`Logo ${index + 1}`}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </>
    )
  },
}
